import { GENERAL_CONSTANTS } from 'components/shared/general.constants';

//TODO Think about moving this logic and dataLayer.push into e.g. googleAnalyticsService

export const enrichGoogleAnalyticsSuffix = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }

  return value + GENERAL_CONSTANTS.ID_HASH_SUFFIX;
};
